export enum EntityType {
  EMAIL = 'EMAIL',
  MOBILE = 'MOBILE',
  USER_ID = 'USER_ID',
  PARTNER_ID = 'PARTNER_ID',
  AGENT_ID = 'AGENT_ID',
  DEVICE = 'DEVICE',
  MEMBER_ID = 'MEMBER_ID',
  FAMILY_MEMBER_ID = 'FAMILY_MEMBER_ID',
}
